import { render, staticRenderFns } from "./ReactionButton.vue?vue&type=template&id=0a35f30b&scoped=true&"
import script from "./ReactionButton.vue?vue&type=script&lang=js&"
export * from "./ReactionButton.vue?vue&type=script&lang=js&"
import style0 from "./ReactionButton.vue?vue&type=style&index=0&id=0a35f30b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a35f30b",
  null
  
)

export default component.exports